<template>
  <div class="w-100 d-flex align-items-center part-select">
    <div v-if="item.imageDefault">
      <ProductsImagePreview v-if="preview" :item="item" :onlyImages="true" :noAssign="true" />
      <div class="part-thumbnail" v-else>
        <img :src="item.imageDefault.url || '/img/loading-img.png'" class="w-100 p-2" />
      </div>
    </div>

    <div class="ml-2 d-flex justify-content-between w-100">
      <div class="text-left">
        <h6 class="m-0">
          {{ item.productId }}
        </h6>

        <small v-if="item.productName || item.supplierCode">{{
          [item.productName, item.supplierCode].filter((e) => e).join(' ')
        }}</small>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProductDropdownOption',
  props: {
    /**
     * Product object containing:
     * @property {String} imageDefault.url - URL of the product image
     * @property {String} productId - Unique identifier of the product
     * @property {String} productName - Name of the product
     * @property {String} supplierCode - Code from the supplier
     */
    item: {
      type: Object,
      required: true
    },
    /**
     * Flag to control whether to show the full image preview
     * @type {Boolean}
     */
    preview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ProductsImagePreview: () => import('../portals/Administration/Products/ProductImagePreView')
  }
};
</script>
